import { useRequest } from "../../../app/hooks/useRequest";
import { deleteFollowUpRequest } from "../FollowUpRequests";

export const useDeleteFollowUp = () => useRequest(deleteFollowUpRequest);
